import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import SelectUserComboBox from '../../../../components/SelectUserComboBox';
import assignmentIcon from '../../../../assets/images/assign.svg';
import animator from '../../../../helpers/animator';
import UserAvatar from '../../../../components/UserAvatar';
import Animate from '../../../../components/Animate';
import dataModel from '../../../../models/DataModel';

import './ReplaceProjectMemberPopup.scss';

export class ReplaceProjectMemberPopup extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { menu: null, openEditOptions: false, selectedUser: null, users: [] };
    this.animated = false;
    this.animator = new animator();
  }

  componentDidMount() {
    if (this.props.project.location && this.props.project.location.market_id) {
      dataModel.marketsDAO.getMarket(this.props.project.location.market_id, null, {
        recordDescriptor: {
          market:
          {
            users: {},
            market_users:
              { user: { additionalFields: ['profile_image'] } },
            market_vendor_users:
            {
              vendor_user: { additionalFields: ['profile_image'], vendor_company: {} },
            },
            vendor_users: { additionalFields: ['profile_image'], companies: {} },
          },
        
        },
      }).then(market => {
        this.setMarketUsers(market);
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.markets != this.props.markets && this.props.project.location && this.props.project.location.market_id) {
      dataModel.marketsDAO.getMarket(this.props.project.location.market_id, null, {
        recordDescriptor: {
          market:
          {
            users: {},
            market_users:
              { user: { additionalFields: ['profile_image'] } },
            market_vendor_users:
            {
              vendor_user: { additionalFields: ['profile_image'], vendor_company: {} },
            },
            vendor_users: { additionalFields: ['profile_image'], companies: {} },
          },
        
        },
      }).then(market => {
        this.setMarketUsers(market);
      });
    }
  }

  setMarketUsers(market) {
    if (market) {
      let users = [];
      if (market.users) {
        market.users.forEach(user => {
          if (!user.suspended && !users.find(u => {return u.id == user.id;})) {
            users.push(user);
          }
        });
      }
      if (market.market_users) {
        market.market_users.forEach(marketUser => {
          if (!marketUser.user.suspended && !users.find(u => {return u.id == marketUser.user.id;})) {
            users.push(marketUser.user);
          }
        });
      }

      if(market.vendor_users) {
        market.vendor_users.forEach(user => {
          if (!user.suspended && !users.find(u => {return u.id == user.id;})) {
            users.push(user);
          }
        });
      }

      if(market.market_vendor_users) {
        market.market_vendor_users.forEach(mvu => {
          if (!mvu.vendor_user.suspended && !users.find(u => {return u.id == mvu.vendor_user.id;})) {
            users.push(mvu.vendor_user);
          }
        });
      }
      this.setState({ users, market });
    }
  }

  animateMe() {
    this.animated = true;
    const _this = this;
    setTimeout(() => {
      const ani = _this.animator.createPropertyAnimation('replace-project-member-popup' + this.props.project.id, 300, {
        opacity: { startVal: 0, endVal: 1 },
      });
      _this.animator.addAnimation(ani);
      _this.animator.processAnimationQueue();
    }, 10);
  }

  handleClose(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ animateClose: true });
  }

  handleSelection(type, option) {
    dataModel.usersDAO.getUser(option.user.id).then((user) => {
      this.setState({ selectedUser: user, currentAssignmentType: null });
    });
  }

  handleReplaceMember(e) {
    e.stopPropagation();
    if (this.props.replaceMember && this.state.selectedUser) {
      this.props.replaceMember(this.state.selectedUser);
      this.handleClose(e);
    }
  }

  handleKeyDown(e) {
    e.stopPropagation();
    if (e.keyCode == 13 || e.keyCode == 40) {
      e.preventDefault();
      this.handleReplaceMember(e);
    }
    else if (e.keyCode == 27) {
      e.preventDefault();
      this.handleClose(e);
    }
  }

  handleAnimateOut() {
    if (this.props.handlePopupClose) {
      this.props.handlePopupClose();
    }
  }

  handleBackgroundClicked(e) {
    e.stopPropagation();
    if (e.target == this.background)
      this.handleClose(e);
  }

  handleQuickerAssignSelection(e) {
    e.stopPropagation();
    if (this.props.handleDisplayQuickerAssign) {
      this.props.handleDisplayQuickerAssign(this.props.project, this.props.selectedUser);
      this.handleClose(e);
    }
  }

  render() {
    let { project, left, right, top, multiSelect, isBuildOwner } = this.props;
    if (project == undefined) {
      return null;
    }

    if (!this.animated) {
      this.animateMe();
    }
    let selectedUser = this.state.selectedUser ? this.state.selectedUser : null;
    let style = {};
    if (left) {
      style = { top: top, left: left };
    }
    else {
      style = { top: top, right: right };
    }

    let combinedUsers = this.state.users.filter(users => {
      return true;
    });
    
    let userName = this.props.selectedUser.first_name + ' ' + this.props.selectedUser.last_name;
    let userCompany, userTitle;
    if (this.props.selectedUser.companies) {
      userCompany = this.props.selectedUser.companies && this.props.selectedUser.companies.length > 0 ?
        this.props.selectedUser.companies[0].name :
        this.props.selectedUser.vendor_companies && this.props.selectedUser.vendor_companies.length > 0 ? this.props.selectedUser.vendor_companies[0].name : '';
    }
    if (this.props.selectedUser.title) {
      userTitle = this.props.selectedUser.title;
    }

    let assignmentTypeList =  [
      { type: 'field_user', name: 'Assigned to' },
      { type: 'reviewer', name: 'Reviewer' },
      { type: 'approver', name: 'Approver' },
      { type: 'notify_task', name: 'Task - Notify' },
      { type: 'notify_build', name: 'Build - Notify' },
    ];

    if (this.props.selectedUser.role.name == 'editor' || 
        this.props.selectedUser.role.name == 'admin') 
    {
      assignmentTypeList.push({ type: 'build_owner', name: 'Build Owner' });
    }

    if (isBuildOwner) {
      assignmentTypeList = [ 
        { type: 'field_user', name: 'Assigned to' },
        { type: 'reviewer', name: 'Reviewer' },
        { type: 'notify_task', name: 'Notify - Task' },
      ];
    }

    let animateHeight = isBuildOwner ? 180 : userTitle ? 248 : 224;

    return (
      <div className="replace-project-member-background" onClick={this.handleBackgroundClicked}
        ref={element => { this.background = element; }}>
        <div id={'replace-project-member-popup' + this.props.project.id} className="replace-project-member-popup"
          style={style} onKeyDown={this.handleKeyDown}>
          <Animate key="animate_popup-in" component_id={'replace-project-member-popup' + this.props.project.id} duration={500}
            property={{ height: { startVal: 0, endVal: animateHeight } }} />
          {this.state.animateClose && (
            <Animate key="animate_popup-out" component_id={'replace-project-member-popup' + this.props.project.id} duration={500}
              property={{ height: { startVal: animateHeight, endVal: 0 } }} completionCallback={this.handleAnimateOut} />
          )}
          <div className="close-button" onClick={(e) => { this.handleClose(e); }}></div>
          <div className="user-description">
            <div className="avatar-container">
              <UserAvatar user={this.props.selectedUser} larger={true}/>
            </div>
            <div className="user-name">{userName}</div>
            {userTitle && <div className="user-title">{userTitle}</div> }
            {userCompany && <div className="user-company">{userCompany}</div> }
          </div>
          <div className={'selection-section user-section' + (isBuildOwner ? ' selection-section--build-owner' : '')}>
            <div className='quicker-assign'>
              <img className='assignment-icon' src={assignmentIcon} alt="assign" />
              <div className='assignment-caption'>Assign</div>
              <div className='assignment-button' onClick={(e) => {this.handleQuickerAssignSelection(e);}}>ASSIGN</div>
            </div>
              { !isBuildOwner &&
                <div className="entry-field">
                  <div className="label">
                    <div className="user-label">REPLACE&nbsp;</div>
                    <div className="user-name wide">{userName.trim().toUpperCase()}</div>
                    <div className="user-label">&nbsp;WITH</div>
                  </div>
                  <div className="field-container">
                  <div className="field">
                      <SelectUserComboBox 
                        id={'replace-project-member-combobox'} 
                        key={'replace-project-member-combobox' + (this.state.selectedUser ? this.state.selectedUser.id : '')} 
                        width={188} 
                        defaultText={'Select User'}
                        small={true}
                        hasBorder={false} 
                        users={combinedUsers}
                        multiSelect={multiSelect}
                        noBackground={false}
                        handleSelection={this.handleSelection} 
                        currentSelectedUser={selectedUser} 
                        adjustHeight={true}
                      />
                    </div>
                    <div className={'field-button' + (this.state.selectedUser ? ' enabled' : '')} onClick={(e) => {this.handleReplaceMember(e);}}>Replace</div>
                  </div>
                </div>
              }
            </div>
        </div>
      </div>
    );
  }
}

// Change to appropriate class name

const mapStateToProps = (state) => {
  return {
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
  };
};

export default withRouter(connect(mapStateToProps)(ReplaceProjectMemberPopup));



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectCRUD/ReplaceProjectMemberPopup/index.js